export enum Tool {
  Measure,
  Move,
}

export default Tool
